__turbopack_context__.v({
  "arrow": "jKOrrW_arrow",
  "arrowIcon": "jKOrrW_arrowIcon",
  "caption": "jKOrrW_caption",
  "card": "jKOrrW_card",
  "comingSoon": "jKOrrW_comingSoon",
  "fallback": "jKOrrW_fallback",
  "fromLabel": "jKOrrW_fromLabel",
  "image": "jKOrrW_image",
  "media": "jKOrrW_media",
  "navButton": "jKOrrW_navButton",
  "next": "jKOrrW_next",
  "overlay": "jKOrrW_overlay",
  "prev": "jKOrrW_prev",
  "price": "jKOrrW_price",
  "priceColumn": "jKOrrW_priceColumn",
  "priceLine": "jKOrrW_priceLine",
  "priceRow": "jKOrrW_priceRow",
  "slide": "jKOrrW_slide",
  "title": "jKOrrW_title",
  "track": "jKOrrW_track",
  "viewport": "jKOrrW_viewport",
});
